module.exports = __webpack_public_path__ + "img/data-subject.378eaff1.svg";